var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomTotalViews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_0_316)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0005 12C10.0005 12.5304 10.2112 13.0391 10.5863 13.4142C10.9613 13.7893 11.4701 14 12.0005 14C12.5309 14 13.0396 13.7893 13.4147 13.4142C13.7898 13.0391 14.0005 12.5304 14.0005 12C14.0005 11.4696 13.7898 10.9609 13.4147 10.5858C13.0396 10.2107 12.5309 10 12.0005 10C11.4701 10 10.9613 10.2107 10.5863 10.5858C10.2112 10.9609 10.0005 11.4696 10.0005 12Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.1 17.936C12.7349 17.9791 12.3676 18.0005 12 18C8.4 18 5.4 16 3 12C5.4 8 8.4 6 12 6C15.6 6 18.6 8 21 12",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12B76A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.9995 16L16.9995 19H20.9995L18.9995 22",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#12B76A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomTotalViews);
export default __webpack_public_path__ + "static/media/room-total-views.ad186cccab9592c06ff6529715dc8149.svg";
export { ForwardRef as ReactComponent };